import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetOrderList } from '@/api/DeliveryCode';
import util from '@/libs/util';
import store from '@/store/index';
export default {
  props: {
    isShowChangeOrderDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      keyName: 'BILL_NO',
      keyList: [{
        value: 'ALL',
        label: '全部'
      }, {
        value: 'BILL_NO',
        label: '采购订单号'
      }, {
        value: 'PART_NO',
        label: '物料编码'
      }, {
        value: 'PART_NAME',
        label: '物料名称'
      }, {
        value: 'PART_DESCR',
        label: '规格描述'
      }, {
        value: 'PO_UNIT',
        label: '采购单位'
      }],
      DELIVERY_NO: null,
      pageInfo: {
        TotalCount: null,
        Page: 1,
        Limit: 10
      },
      times: [],
      START_TIME: null,
      END_TIME: null
    };
  },
  methods: {
    handleDate: function handleDate() {
      // console.log('times',this.times);
      if (this.times !== null) {
        this.START_TIME = this.times[0];
        this.END_TIME = this.times[1];
      } else {
        this.START_TIME = null;
        this.END_TIME = null;
      }
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.pageInfo.Page = value;

      this._getOrderlist();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.pageInfo.Limit = value;

      this._getOrderlist();
    },
    handleClear: function handleClear() {
      this.DELIVERY_NO = null;

      this._getOrderlist();
    },
    currentChange: function currentChange(_ref) {
      var newValue = _ref.newValue,
          oldValue = _ref.oldValue,
          row = _ref.row,
          rowIndex = _ref.rowIndex,
          $rowIndex = _ref.$rowIndex,
          column = _ref.column,
          columnIndex = _ref.columnIndex,
          $columnIndex = _ref.$columnIndex,
          $event = _ref.$event;
      // console.log(row);
      // console.log(rowIndex);
      // console.log($rowIndex);
      this.$refs.xTable.setRadioRow(this.tabelData[rowIndex]);
    },
    // 行样式
    rowClassName: function rowClassName() {
      return 'rowClass';
    },
    _getOrderlist: function _getOrderlist() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('currentRow',currentRow);
                _this.tabelData = [];
                params = {
                  ORGANIZE_ID: util.cookies.get('ORG_ID'),
                  DELIVERY_NO: _this.DELIVERY_NO,
                  START_TIME: _this.START_TIME,
                  END_TIME: _this.END_TIME,
                  Page: 1,
                  Limit: 10 // LIST_ROUTE:store.getters.routerPath,

                };
                _this.loading = true;
                _context.next = 5;
                return GetOrderList(params);

              case 5:
                res = _context.sent;
                _this.loading = false;
                console.log('送货单列表', res);

                if (res.code === 0) {
                  _this.tabelData = res.data.Items;
                  _this.pageInfo.TotalCount = res.data.TotalCount;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 去重
    deWeight: function deWeight(asyncRow, currentRow) {
      // let currentRow = this.$refs.xTable.getTableData().visibleData
      // return asyncRow.filter((v) => currentRow.every((val) => val.PO_NO != v.BILL_NO && val.BILL_ITEM != v.PO_ITEM && val.BILL_ITEM != v.PO_ITEM));
      return asyncRow.filter(function (v) {
        return currentRow.every(function (val) {
          return val.PO_NO != v.PO_NO && val.BILL_ITEM != v.BILL_ITEM && val.BILL_ITEM != v.BILL_ITEM;
        });
      });
    },
    getOrderlist: function getOrderlist() {
      this._getOrderlist();
    },
    handleCancel: function handleCancel() {
      this.$emit('closeChangeOrderDialog');
    },
    // 获取当前时间
    getNowDate2: function getNowDate2(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    // 获取当前时间
    getNowDate: function getNowDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y.toString() + m.toString() + d.toString();
    },
    handleDelSubmit: function handleDelSubmit() {
      var selectRecords = this.$refs.xTable.getRadioRecord(); // console.log('selectRecords',selectRecords);

      this.$emit('cbDialogSubmit', selectRecords);
      this.$emit('closeChangeOrderDialog');
    }
  }
};